module.exports = __webpack_public_path__ + "static/banners-001-b4ab859e0db10f2510a2cc0ba3b0ab14.jpg";